import React from 'react'
import { motion } from 'framer-motion'
import '../carousel/carouselauto.css'



const CarouselAuto = ({images}) => {
  // start()

  return (
    <>
    <div>
    {/* <div class="mtext" data-text="this is a repeated text lorem ipsum">this is a repeated text lorem ipsum</div> */}
    
    <motion.div className='slider-container2'>
        <motion.div className='slider2' drag='x' 
        dragConstraints={{right: 0, left:-2123}} >
        {images.map(obj => (
            <motion.div className='item2'>
              
                  <img src={obj.image} alt=""/>
              
            </motion.div>
        ))}
        </motion.div>
        
    </motion.div>
    </div>
    </>
  )
  
}

export default CarouselAuto